export default __webpack_public_path__ + "assets/bulb-component.e506d257.svg";